<template>
  <SubContent h="550px" @back="toCancel">
    <template v-slot:nav_left> {{enrollUuid ? "编辑精英训练营报名":"创建精英训练营报名"}} </template>
    <div class="page-content">
      <div class="form_wrap">
        <vue-scroll>
          <div class="scroll-content form-content">
            <el-form
              :inline="false"
              ref="form"
              :model="form"
              label-width="220px"
              :rules="formRules"
            >
              <el-form-item label="报名类型" prop="enrollType"
                :rules="[{ required: true, message: '类型为必选项', trigger: 'blur' }]">
                <el-select v-model="form.enrollType" placeholder="类型为必选项"  class="w380" disabled>
                  <el-option
                    v-for="(item,index) in enrollTypeList"
                    :key="index"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="性别" prop="enrollSex"
                :rules="[{ required: true, message: '性别为必选项', trigger: 'change' }]">
                <el-select v-model="form.enrollSex" placeholder="类型为必选项"  class="w380" @change="changePeriod">
                  <el-option key="男子" value="男子" abel="男子"></el-option>
                  <el-option key="女子" value="女子" abel="女子"></el-option>
                  <el-option key="男女混合" value="男女混合" abel="男女混合"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                label="训练营开办月份" required
              >
                <el-form-item class="date-form-item" prop="trainCampStartTime"
                  :rules="[{ required: true, message: '请选择开始时间',trigger: 'change'  }]">
                  <el-date-picker
                    type="month"
                    :editable="false"
                    :clearable="true"
                    :picker-options="trainStartOpt"
                    value-format="timestamp"
                    placeholder="请选择开始时间"
                    v-model="form.trainCampStartTime"
                    style="width: 100%;"
                    @change="changeTrainStart"
                  ></el-date-picker>
                </el-form-item>
                <span class="date-form-text">————</span>
                <el-form-item class="date-form-item" prop="trainCampEndTime"
                  :rules="[{ required: true, message: '请选择结束时间',trigger: 'change'  }]">
                  <el-date-picker
                    type="month"
                    :editable="false"
                    :clearable="true"
                    value-format="timestamp"
                    :picker-options="trainEndOpt"
                    placeholder="请选择结束时间"
                    v-model="form.trainCampEndTime"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-form-item>
              </el-form-item>
              <el-form-item label="训练营报名次数" prop="period"
                :rules="[{ required: true, message: '请输入次数',trigger: 'blur'}]">
                <span class="text_line left">第</span>
                <el-input-number
                  v-model="form.period"
                  controls-position="right"
                  :min="1"
                  :step="1"
                  step-strictly
                  style="width:334px;margin:0 5px"
                  @change="changePeriod"
                ></el-input-number>
                <span class="text_line right">次</span>
              </el-form-item>
              <el-form-item label="训练营报名名称" prop="enrollName"
                :rules="[{ required: true, message: '大区训练营计划名称为必填项', trigger: 'change'  }]">
                <el-input v-model="form.enrollName" class="w380" placeholder="请输入大区训练营计划名称" maxlength="50" show-word-limit></el-input>
              </el-form-item>
              <el-form-item label="名单提交截止时间" required >
                <el-form-item class="date-form-item" prop="enrollEndTime" style="width:380px"
                  :rules="[{ required: true, message: '请选择截止时间',trigger: 'change'  }]">
                  <el-date-picker
                    type="date"
                    :editable="false"
                    :clearable="true"
                    :picker-options="enrollStartOpt"
                    value-format="timestamp"
                    placeholder="请选择截止时间"
                    v-model="form.enrollEndTime"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-form-item>
              </el-form-item>

              <el-form-item label="球员年龄段" prop="playerAges" :rules="[
                      { required: true, message: '请选择球员年龄段', trigger: 'change' },
                    ]" v-if="form.enrollType === 'player'">
                <el-select v-model="form.playerAges" placeholder="选择球员年龄段"  clearable  class="w380" multiple>
                  <el-option
                    v-for="(item,index) in playerAgeList"
                    :key="index"
                    :value="item"
                    :label="item"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="训练营报名信息">
                <quill-editor
                  class="editor-box"
                  ref="textEditor"
                  v-model="form.intro"
                  :options="editorOption"
                ></quill-editor>
              </el-form-item>
            </el-form>
          </div>
        </vue-scroll>
      </div>
    </div>
    <template v-slot:btn>
      <div class="btn_wrap">
        <el-button type="primary" @click="save('Edit')">暂时保存</el-button>
        <el-button type="primary" @click="save('Incomplete')">确认创建</el-button>
        <el-button type="danger" @click="toCancel">取消</el-button>
      </div>
    </template>
    <yioks-tips
      :showTip="tipsFlagCancel"
      tipMsg="请确认放弃保存并返回吗？"
      :loading="repeatSubmitCancel"
      @callback="hideTipsDialogCancel"
    ></yioks-tips>
    <yioks-tips
      :showTip="tipsFlag"
      :tipMsg="msg"
      :loading="repeatSubmit"
      @callback="hideTipsDialog"
    ></yioks-tips>
  </SubContent>
</template>
<script>
  import trainCamp from '@/api/trainCampEnroll'
  import { quillEditor } from 'vue-quill-editor' // 富文本编辑器，下面的样式必须引入
  import { timeYearAndMonth } from '@/utils/yioks_filter' // 富文本编辑器，下面的样式必须引入
  import { trainCampEnrollType } from '@/utils/yioks_filter'
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
export default {
  name: "trainCampEnrollAdd",
  data() {
    const editorOption = {
      placeholder: '请填写训练营报名信息',
      modules: {
        toolbar: [
          ["bold", "italic", "underline", "strike", "link", "blockquote"],
          [{ 'indent': '-1' }, { 'indent': '+1' }],
          [{ color: [] }, { background: [] }],
          [
            { size: ["small", false, "large", "huge"] },
            { header: [1, 2, 3, 4, 5, 6, false] }
          ],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ align: [] }],
          ["clean"]
        ]
      }
    };
    const enrollType = this.$route.query.enrollType;
    return {
      enrollTypeList: [{value:"player",label:"球员"},{value:"coach",label:"教练"}],
      playerAgeList:[],
      editorOption,
      form: {
        enrollType:enrollType,
        enrollSex:"",
        enrollEndTime:"",
        trainCampStartTime:"",
        trainCampEndTime:"",
        enrollName:"",
        period:"",
        playerAges:[],
        intro:"",
        enrollStatus:"",
      },
      msg:"请确认暂时保存并退出?",
      ifNameDiaShow: false,
      tipsFlagCancel: false,
      repeatSubmitCancel: false,
      tipsFlag: false,
      repeatSubmit: false,
      formRules: {

      },
    }
  },
  components: {
    SubContent: () => import("@/components/layout/contentWithbtn"),
    "yioks-tips": () => import("@/components/YioksTip"),
    quillEditor
  },
  computed: {
    enrollUuid(){
      const uuid = this.$route.query.enrollUuid || "";
      return uuid;
    },
    trainStartOpt() {
      return {
        disabledDate: time =>{
          const tempDate = new Date().setHours(0,0,0,0);
          let timestamp = new Date(tempDate).getTime();
          return time.getTime() < timestamp;
        },
      };
    },
    trainEndOpt() {
      return {
        // 这里如果不使用箭头函数则无法正确访问到 this
        disabledDate: time =>{
          if(Number(this.form.trainCampStartTime)) {
            return time.getTime() < Number(this.form.trainCampStartTime);
          } else {
            return time.getTime() < new Date().getTime();
          }
        },
      };
    },
    enrollStartOpt() {
      return {
        // 这里如果不使用箭头函数则无法正确访问到 this
        // 小于当天0点的时间不可用
        // 当前日次 + 7天  C级是14天
        disabledDate: time =>{
          const tempDate = new Date().setHours(0,0,0,0);
          let timestamp = new Date(tempDate).getTime();
          return time.getTime() < timestamp;
        },
      };
    },
  },
  created() {
    this.ageList();
  },
  mounted() {
    // 如果有enrollUuid 说明是编辑
    if (this.enrollUuid) {
      this.getTrainCampEnrollInfo();
    }
  },
  methods: {
    getTrainCampEnrollInfo(){
      trainCamp.getTrainCampEnrollInfo(this.enrollUuid).then(
        (res)=>{
          if (!res.code) {
            this.form = res;
            if(res.playerAges && res.playerAges.length){
              this.form.playerAges = res.playerAges.split(",")
            }
          }else{
            this.$message.error(res.msg);
          }
        }
      )
    },

    //保存
    save(val){
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$set(this.form,"enrollStatus",val)
          if (val === 'Incomplete'){
            this.msg = "请确认是否创建精英训练营报名?"
          }else{
            this.msg = "请确认暂时保存并退出?"
          }
          this.tipsFlag = true;
        }else {
          this.$message.error("请完善所有带 * 的必填项");
        }
      });
    },
    hideTipsDialog(ok) {
      if (ok) {
        if (!this.repeatSubmit) {
          this.repeatSubmit = true;
          this.$refs["form"].validate((valid) => {
            if (valid) {
              // 先给年龄段拍个序 从小到大
              if (this.form.playerAges){
                this.form.playerAges = this.form.playerAges.sort((pre, next) => {
                  return  pre - next;
                });
              }

              let requestData = {
                trainCampEnroll:{
                  ...this.form,
                  playerAges:this.form.playerAges && this.form.playerAges.join(",")
                },
              }

              let requestName = trainCamp.addTrainCampEnroll; // 添加
              if (this.enrollUuid){// 说明是编辑
                requestName = trainCamp.editTrainCampEnroll;
              }

              requestName(requestData).then((res) =>{
                this.repeatSubmit = false;
                this.tipsFlag = false;
                if (res.code) {
                  this.$message.error(res.msg);
                } else {
                  this.$message.success("信息保存成功");
                  this.$router.go(-1);
                }
              })
              .catch((err) => {
                this.repeatSubmit = false;
                this.tipsFlag = false;
                console.log(err);
              });
            }
          });
        }
      } else {
        this.repeatSubmit = false;
        this.tipsFlag = false;
      }
    },
    /* 取消 */
    toCancel() {
      this.tipsFlagCancel = true;
    },
    hideTipsDialogCancel(ok) {
      if (ok) {
        this.repeatSubmitCancel = false;
        this.tipsFlagCancel = false;
        this.$router.go(-1);
      } else {
        this.repeatSubmitCancel = false;
        this.tipsFlagCancel = false;
      }
    },
    changePeriod(){
      if (this.form.trainCampStartTime){
        const year = timeYearAndMonth(this.form.trainCampStartTime).substr(0,4)
        const type = trainCampEnrollType(this.form.enrollType)
        this.form.enrollName = `${year}年上海足协第${this.form.period}次${this.form.enrollSex}精英训练营报名`
      }
    },
    changeTrainStart(){
      const year = timeYearAndMonth(this.form.trainCampStartTime).substr(0,4)
      if(this.form.trainCampStartTime){
        trainCamp.trainCampEnrollPeriod(year,this.form.enrollType).then(
          (res)=>{
            if (!res.code) {
              this.form.period = res;
              const type = trainCampEnrollType(this.form.enrollType)
              this.form.enrollName = `${year}年上海足协第${this.form.period}次${this.form.enrollSex}精英训练营报名`
            }else{
              this.$message.error(res.msg);
            }
          }
        )
      }

    },

    // 年龄段
    ageList(){
      const small = 12;
      const big = 17;
      const year1 = new Date().getFullYear()-big;
      const year2 = new Date().getFullYear()-small;
      let list = [];
      for (let i = year1 ; i <= year2 ;  i++ ){
        list.push(i.toString())
      }
      this.playerAgeList = list;
    },

  }
}
</script>
<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.form_wrap
  padding 20px
  overflow hidden
  box-sizing border-box
  flex 1
  font-size 16px
  height 550px
  .w380
    width 380px
  .date-form-item
    width 154px
    float left
  .date-form-text
    text-align center
    float left
    margin 0 8px
.btn_wrap
  width 100%
  display flex
  justify-content center
.btns
  text-align center
</style>
<style lang="stylus">
  .page-content
    .el-steps--simple
      background-color rgba(0, 0, 0, 0)
    .el-form-item__label
      color #fff
      font-size 16px
  .editor-box
    background-color #fff
    color #333
    line-height 1
    word-break break-all
    word-wrap break-word
    width: 530px;
    margin-top: 12px;
    .ql-toolbar.ql-snow .ql-formats
      margin-right: 10px
    .ql-container
      min-height 150px
</style>
<style lang="stylus">
  @import '~@/assets/css/variable'
  .yioks-switch
  .el-switch__label
    color $color_white
  .el-switch__label--left
    &.is-active
      color $color_white
  .el-switch__label--right
    &.is-active
      color $green_color
  .yioks-switch-grey
    .el-switch__label
      color $grey_color
    .el-switch__label--left
      &.is-active
        color $grey_color
    .el-switch__label--right
      &.is-active
        color $green_color
</style>
